import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../../../core/settings/msal-config";
import {
  Popup,
  Button,
  AddIcon,
  MoreIcon,
  Avatar,
} from "@fluentui/react-northstar";
import { AppURLProps } from "../../../../core/settings/app-urls";

const AccountPicker = ({
  handleInteractiveSignin,
  history,
  capitalizeFirstLetter,
}) => {
  const { instance } = useMsal();
  const accountDetails = instance.getAllAccounts();
  const activeUserAccount = instance.getActiveAccount();
  const filteredAccounts = accountDetails.filter((account) => {
    if (account.homeAccountId !== activeUserAccount.homeAccountId) {
      return account;
    }
    return false;
  });

  const handleListItemClick = async (account) => {
    await instance.setActiveAccount(account);
    await instance
      .acquireTokenSilent({
        ...loginRequest,
        loginHint: account.username,
        prompt: "none",
      })
      .then(async (res) => {
        handleInteractiveSignin(res.idToken, history, res.account);
      })
      .catch(async (err) => {
        console.log(err);
      });
  };

  const handleAddAccount = () => {
    history.push(AppURLProps.signin);
  };

  const handleSignout = (account) => {
    instance.logoutRedirect({
      onRedirectNavigate: (url) => {
        return false;
      },
      account: instance.getAccountByHomeId(account.homeAccountId),
    });
  };

  return (
    <div className="profile-card-account-list-container">
      <ul className="profile-card-account-list">
        {filteredAccounts.map((account) => {
          return (
            <li key={account.homeAccountId}>
              <div className="profile-card-account-item">
                <div
                  className="profile-card-remembered-account"
                  onClick={() => handleListItemClick(account)}
                >
                  <Avatar
                    name={capitalizeFirstLetter(account.name)}
                    className="profile-card-remembered-account-switch-image"
                  />
                  <div className="profile-card-remembered-account-info">
                    <div className="profile-card-remembered-account-displayname text-truncate text-semibold">
                      {account.name}
                    </div>
                    <div className="profile-card-remembered-account-number text-truncate">
                      {account.username}
                    </div>
                  </div>
                </div>
                <div className="profile-card-remembered-account-action">
                  <Popup
                    trigger={
                      <Button text iconOnly icon={<MoreIcon />}></Button>
                    }
                    content={
                      <Button
                        primary
                        onClick={() => handleSignout(account)}
                        text
                        content={"Sign out"}
                      />
                    }
                  />
                </div>
              </div>
            </li>
          );
        })}
        <li onClick={() => handleAddAccount()}>
          <div className="profile-card-account-item">
            <div className="profile-card-remembered-account">
              <div className="profile-card-remembered-account-signin-image">
                <div className="profile-card-remembered-account-signin-icon">
                  <AddIcon size="smaller" />
                </div>
              </div>
              <div className="profile-card-remembered-account-info">
                <div className="profile-card-remembered-account-signin text-truncate">
                  Sign in with a different account
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default AccountPicker;
